import { c as _c } from "react/compiler-runtime";
import { SidebarProvider } from '@/components';
import { useSubscription } from '@/context/SubscriptionProvider';
import { useCurrentUserRole } from '@/context/UserRoleProvider';
import { ReactNode } from 'react';
import { AppSidebar } from './AppSidebar';
import { GetStartedBanner } from './GetStartedBanner';
import { Header } from './Header';
import { OnboardingChecklist } from './OnboardingChecklist';
import { TopBar } from './TopBar';
type DesktopLayoutProps = {
  children: ReactNode;
  hideSidebar?: boolean;
};
const DesktopLayout = t0 => {
  const $ = _c(8);
  const {
    children,
    hideSidebar: t1
  } = t0;
  const hideSidebar = t1 === undefined ? false : t1;
  const {
    hasActiveSubscription,
    loading
  } = useSubscription();
  const {
    isInternalUser,
    isLoading: isRoleLoading
  } = useCurrentUserRole();
  const isDev = process.env.NEXT_PUBLIC_ENV === "dev" || process.env.NEXT_PUBLIC_ENV === "local";
  const showSidebar = !hideSidebar && (loading || isRoleLoading || hasActiveSubscription || isInternalUser || isDev);
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <TopBar />;
    t3 = <Header />;
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  let t4;
  if ($[2] !== children || $[3] !== showSidebar) {
    t4 = <div className="flex-1 relative min-h-0 overflow-hidden rounded-2xl border">{showSidebar ? <SidebarProvider><AppSidebar /><main className="flex-1 overflow-auto h-full bg-background border-l border-border flex flex-col"><GetStartedBanner /><div className="flex-1 min-h-0 overflow-auto">{children}</div></main></SidebarProvider> : <main className="flex-1 overflow-auto h-full bg-background flex flex-col"><GetStartedBanner /><div className="flex-1 min-h-0 overflow-auto">{children}</div></main>}</div>;
    $[2] = children;
    $[3] = showSidebar;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <OnboardingChecklist />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t4) {
    t6 = <div className="flex flex-col h-dvh overflow-hidden p-3 gap-3">{t2}{t3}{t4}{t5}</div>;
    $[6] = t4;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  return t6;
};
export { DesktopLayout };